<div class="upload-progress" *ngIf="showProgress" [class.minimized]="minimized">
  <div class="header" (click)="toggleMinimize()">
    <div class="title">
      <i class="bi bi-cloud-upload"></i>
      <span>Uploading Files ({{ getActiveUploads().length }})</span>
    </div>
    <div class="actions">
      <div class="progress-text">{{ getTotalProgress() }}%</div>
      <button type="button" class="btn btn-icon">
        <i class="bi" [class.bi-chevron-down]="!minimized" [class.bi-chevron-up]="minimized"></i>
      </button>
    </div>
  </div>

  <div class="progress-bar">
    <div class="progress" [style.width.%]="getTotalProgress()"></div>
  </div>

  <div class="body" *ngIf="!minimized">
    <div class="upload-list">
      <div class="upload-item" *ngFor="let upload of getActiveUploads()">
        <div class="file-info">
          <i class="bi bi-file-earmark-text"></i>
          <span class="name">{{ upload.file.name }}</span>
          <span class="size">({{ upload.file.size | fileSize }})</span>
        </div>
        <div class="status">
          <div class="progress-text">{{ upload.progress }}%</div>
          <i class="bi" [ngClass]="{
            'bi-check-circle-fill text-success': upload.status === 'completed',
            'bi-x-circle-fill text-error': upload.status === 'error',
            'bi-arrow-repeat spin': upload.status === 'uploading'
          }"></i>
        </div>
      </div>
    </div>
  </div>
</div> 